exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.multiline-header[data-v-45cc0b86] {\n    display: inline-block;\n    text-align: left;\n}\n.nudge-up[data-v-45cc0b86] {\n    position: relative;\n    top: -4px;\n}\n", ""]);

// exports
